/**
 * Created by Alex Xia on 05/31/2023.
 * Description:
 * Ag-grid visible button
 * ------ maintenance history ------
 */

import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NotificationOptions } from '../../../../widgets/notification/notification.model';
import { NotificationModel } from '../../../../tamalelibs/models/notification.model';
import { NotificationService } from '../../../../tamalelibs/services/notification.service';
import { catchError, take } from 'rxjs/operators';
import { of as observableOf } from 'rxjs';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { NotificationActionTypes } from '../../../../redux/actions/notification.actions';

@Component({
    selector: 'tam-admin-notification-active',
    template:
        `<div kendoTooltip>
            <kendo-switch onLabel="Yes" offLabel="No" title="Activate/Deactivate" [(ngModel)]="isActive" (click)="clicked($event)"></kendo-switch>
        </div>`,
    styleUrls: ['./admin-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminNotificationActiveComponent implements ICellRendererAngularComp {
    isActive: boolean;
    title: String;
    private _notification: NotificationModel;

    constructor(
        private _notificationService: NotificationService,
        private _store: Store<AppState>,
        private _toast: ToastService,
        private _changeDetectorRef: ChangeDetectorRef,
    ) { }

    agInit(params: any): void {
        this._notification = Object.assign({}, params.data);
        this.isActive = params.data.active;
        this._changeDetectorRef.detectChanges();
    }

    clicked(event: any): void {
        this._notification.active = this.isActive;
        const notificationId = this._notification.id;
        const status = this._notification.active;
        this._notificationService.changeNotificationStatus(notificationId, status).pipe(
            take(1),
            catchError((error) => {
                const _failedToast: NotificationOptions = {
                    message: error.message,
                    style: NotificationStyles.Error
                };
                this._toast.notify(_failedToast);
                return observableOf(null);
            })
        ).subscribe((response) => {
            if (response) {
                this.isActive = response.active;
                const message = this._notification.name + (this.isActive ? ' is enabled successfully.' : ' is disabled successfully.');
                // refresh notification list to set the row color
                this._store.dispatch({
                    type: NotificationActionTypes.GETNOTIFICATIONS
                });
                this._toast.notify({
                    message: message,
                    style: NotificationStyles.Success
                });
            }
            this._changeDetectorRef.detectChanges();
        });
    }

    refresh(): boolean {
        return true;
    }
}
